import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = styled.button`
  cursor: ${({ disabled }) => disabled ? 'progress' : 'pointer'};
  background-color: #f8f9fa;
  border: 1px solid transparent;
  color: ${({ disabled, color }) => disabled ? 'a3a3a3' : color};
  border-radius: 50%;
  margin-left: 0.5rem;
  padding: .25rem .5rem;
  font-size: .875rem;
  line-height: 1.5;
  text-align: center;
  vertical-align: middle;
  z-index: 1;
`;

const ButtonCmp = ({children, color, handleClick, disabled}) => {
  return (
    <Button 
      color={color} 
      onClick={handleClick}
      disabled={disabled}
    >{children}</Button>
  );
};

ButtonCmp.propTypes = {
  handleClick: PropTypes.func,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
};

ButtonCmp.defaultProps = {
  color: "#212529",
};

export default ButtonCmp;
